<template>
  <div>
    <div style="margin-bottom: 10px" class="df both-side">
      <!-- <a-space>
        <custom-select
          @handleUpdateSelectVal="handleUPdateProjectLifeCycle"
          :options="projectLifeCycleOptions"
          placeholder="项目阶段"
          style="width: 160px"
        ></custom-select>

        <a-select
          allowClear
          v-model:value="requestPayload.structureName"
          @change="handleSearch"
          placeholder="研发组织"
          style="width: 160px"
          v-if="hasProjectAuthority"
        >
          <a-select-option value="嵌入式软件部">嵌入式软件部</a-select-option>
          <a-select-option value="结构部">结构部</a-select-option>
          <a-select-option value="算法部">算法部</a-select-option>
          <a-select-option value="光学部">光学部</a-select-option>
          <a-select-option value="云端软件部">云端软件部</a-select-option>
          <a-select-option value="电子部">电子部</a-select-option>
          <a-select-option value="产品设计部">产品设计部</a-select-option>
          <a-select-option value="工程部">工程部 </a-select-option>
        </a-select>

        <a-input
          allowClear
          style="width: 160px"
          placeholder="WBS"
          @change="handleSearch"
          v-model:value="requestPayload.WBS"
        >
        </a-input>
      </a-space>
      <a-button @click="handleUpdateLib(null)" :disabled="actionAuthority"
        >新增</a-button
      > -->
    </div>

    <div style="height: calc(100vh - 160px)">
      <a-table
        :data-source="table.data"
        bordered
        :pagination="false"
        :columns="columns"
        :scroll="{ x: 'calc( 100vw- 80px)', y: 'calc( 100vh - 200px)' }"
        rowKey="id"
      >
        <template #fileType="{ record }">
          <div v-if="record.fileType === 'input'">输入</div>
          <div v-if="record.fileType === 'output'">输出</div>
        </template>

        <template #wbs="{ record }">
          <a-tooltip>
            <template #title>简称/阶段-类型/项目组-编号</template>
            {{ record.wbs }}
          </a-tooltip>
        </template>

        <template #fileLink="{ record }">
          <a-button type="primary" size="small" @click="downloadFile(record)">
            下载
          </a-button>
        </template>

        <template #push="{ record }">
          <a-button
            type="primary"
            size="small"
            @click="handleNoticeStaff(record)"
          >
            推送
          </a-button>
        </template>

        <template #latestVersion="{ record }">
          <div>{{ record.latestVersion ? "是" : "否" }}</div>
        </template>

        <template #action="{ record }">
          <a-space>
            <a-button
              type="primary"
              @click="handleUpdateLib(record)"
              size="small"
              :disabled="actionAuthority"
              v-if="record.userId === user.id"
              >修改</a-button
            >
            <a-button
              @click="handleDeleteRecord(record)"
              :disabled="actionAuthority"
              size="small"
              type="danger"
              v-if="record.userId === user.id"
            >
              删除
            </a-button>
          </a-space>
        </template>
      </a-table>
    </div>

    <!-- <div class="df both-side">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        :show-total="(total) => `共 ${total} 条`"
        v-model:current="table.pageNum"
        v-model:pageSize="table.lineNum"
        @change="handleUpdatePage"
      />
    </div> -->

    <data-base-form
      ref="dataBaseFormRef"
      @hadleUpdateTable="hadleUpdateTable"
    ></data-base-form>

    <notice-staff
      ref="noticeStaffRef"
      @handleSelectStaff="handleSelectStaff"
    ></notice-staff>
  </div>
</template>

<script>
import { defineComponent, ref, watch, computed, inject } from "vue";
import { useStore } from "vuex";
import { useTable } from "@/views/notice/serve/table";
import websocket from "@/utils/base/socket";
import {
  deleteDataLib,
  getRNDDataLibList,
  updateDataLib,
  getOneRNDDataLib,
} from "@/request/view/project";
import {
  libTypeOptions,
  projectLifeCycleOptions,
} from "@/views/rdmanagement/components/database/options";
import dataBaseForm from "@/views/rdmanagement/components/database/form.vue";
import customSelect from "@/views/rdmanagement/components/database/customSelect.vue";
import noticeStaff from "@/components/chooseStaff/index.vue";

import { useRouter, useRoute } from "vue-router";
import { debounce, timeStampToTime } from "@/utils";
import { download } from "@/views/rdmanagement/serve/index";
import store from "@/store";

export default defineComponent({
  props: {
    dataBaseType: String,
  },
  components: { dataBaseForm, customSelect, noticeStaff },
  setup(props) {
    const authorityId = ref(null);
    const user = useStore().state.user.user;

    const hasProjectAuthority = computed(() => authorityId.value == user.id);

    const noticeAuthority = ref(false);

    const dataBaseKey = inject("dataBaseKey", null);

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    const actionAuthority = computed(() => user.custom === null);

    const noticeStaffRef = ref();

    const route = useRoute();

    initPayload({
      dataLibType: null,
      projectLifeCycle: null,
      structureName: null,
      WBS: null,
      projectLifeCycleId: route.query.projectId,
      username: user.username,
    });

    const columns = [
      // {
      //   title: "WBS",
      //   dataIndex: "wbs",
      //   align: "center",
      //   width: "140px",
      //   slots: {
      //     customRender: "wbs",
      //   },
      // },
      {
        title: "文件类型",
        align: "center",
        width: "140px",
        slots: {
          customRender: "fileType",
        },
      },
      {
        title: "文件名称",
        dataIndex: "fileName",
        align: "center",
        width: "200px",
      },
      {
        title: "文件下载",
        align: "center",
        slots: {
          customRender: "fileLink",
        },
        width: "120px",
      },
      {
        title: "推送",
        align: "center",
        slots: {
          customRender: "push",
        },
        width: "120px",
      },
      {
        title: "工作记录",
        dataIndex: "workRecords",
        align: "center",
      },
      {
        title: "设计人",
        dataIndex: "username",
        align: "center",
        width: "120px",
      },
      {
        title: "上传时间",
        dataIndex: "uploadTime",
        align: "center",
        width: "120px",
      },
      {
        title: "最新版本",
        slots: {
          customRender: "latestVersion",
        },
        align: "center",
        width: "120px",
      },
      {
        title: "操作",
        align: "center",
        slots: {
          customRender: "action",
        },
        width: "140px",
      },
    ];

    const dataBaseFormRef = ref();

    requestConfig.pull_fn = getRNDDataLibList;
    requestConfig.delete_fn = deleteDataLib;

    const handleUpdateLib = (record) => {
      dataBaseFormRef.value.showmodal({
        title: record === null ? "新增资料" : "编辑资料",
        type: record === null ? "insert" : "update",
        data: record,
      });
    };

    const getData = debounce(() => {
      console.log(route.query);
      if (route.query.id) {
        getOneRNDDataLib({ id: route.query.id }).then((res) => {
          table.data.length = 0;
          table.data.push(res.data);
        });
      } else {
        getListData();
      }
    }, 300);

    const handleDeleteRecord = (record) => {
      deleteRecords([record.id], { title: "确认删除资料？" }).then((res) => {
        getListData();
      });
    };
    const hadleUpdateLibType = (type) => {
      requestPayload.dataLibType = type;
      table.pageNum = 1;
      getListData();
    };

    const handleUPdateProjectLifeCycle = (type) => {
      requestPayload.projectLifeCycle = type;
      table.pageNum = 1;
      getListData();
    };

    const handleSearch = debounce(() => {
      table.pageNum = 1;
      getListData();
    }, 200);

    const hadleUpdateTable = (isInsert) => {
      if (isInsert) {
        table.pageNum = 1;
      }
      getListData();
    };

    const downloadFile = (record) => {
      download(record.fileLink, "文件");
    };

    const handleUpdatePage = (pageNum, lineNum) => {
      table.pageNum = pageNum;
      table.lineNum = lineNum;
      getData();
    };

    let cacheRecord = null;
    const handleNoticeStaff = (record) => {
      cacheRecord = record;
      noticeStaffRef.value.showModal();
    };

    const getCacheStaffName = (staffName) => {
      let originList = [];
      if (cacheRecord.toUsers) {
        const cacheUser = cacheRecord.toUsers.split(",");
        originList.push(...cacheUser);
      }

      originList.push(...staffName);

      return [...new Set(originList)].toString();
    };

    const handleSelectStaff = (staffId, staffName, staffUserName) => {
      const nickName = user.nickName;
      const localTime = timeStampToTime("", "minutes");
      const { fileName, id, fileLink } = cacheRecord;

      const query = Object.assign(
        {
          id,
          activeKey: "资料库",
          type: "link",
          dataLibType: requestPayload.dataLibType,
          fileName,
          fileLink,
        },
        route.query
      );
      websocket.Send({
        content: `${nickName}在${localTime}推送${fileName}`,
        messageSort: "资料库",
        query: JSON.stringify(query),
        route: "/rdprojectlayout",
        toUserId: staffId,
        type: 0,
        userId: user.id,
      });

      const toUsers = getCacheStaffName(staffUserName);

      updateDataLib({
        id: cacheRecord.id,
        toUsers,
      }).then((res) => {
        getData();
      });
    };

    watch(
      () => dataBaseKey,
      (val) => {
        if (val.value === props.dataBaseType) {
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => route,
      (val) => {
        if (val.path === "/rdprojectlayout") {
          requestPayload.dataLibType = props.dataBaseType;
          requestPayload.projectLifeCycleId = route.query.projectId;

          // requestPayload.WBS = route.query.wbs;
          authorityId.value = route.query.userId;

          if (!hasProjectAuthority.value) {
            requestPayload.structureName =
              user.secondaryDepartment || user.firstLevelDepartment;
          }
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      table,
      user,
      columns,
      noticeAuthority,
      handleSelectStaff,
      actionAuthority,
      handleUpdatePage,
      requestPayload,
      hadleUpdateTable,
      handleDeleteRecord,
      handleUpdateLib,
      hadleUpdateLibType,
      handleSearch,
      handleNoticeStaff,
      handleUPdateProjectLifeCycle,
      downloadFile,
      noticeStaffRef,
      dataBaseFormRef,
      libTypeOptions,
      hasProjectAuthority,
      projectLifeCycleOptions,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
